import React from "react";
import { ICardFirmCompareProps } from "./cardFirmCompare.props";
import { CloseIconWraper } from "../../../components/Modal/modal.styled";
import { Link } from "react-router-dom";
import { API_CONSTANT } from "../../../utils/constant";

const CardFirmCompareComp: React.FC<ICardFirmCompareProps> = (
    {
        data,
        onCloseFirm,
        countFirm,
        ...props
    }: ICardFirmCompareProps
) => {
    const apiDomain = process.env.REACT_APP_API_DOMAIN;

    return <div className="flex flex-row items-center justify-center min-w-[94px] w-full p-[5px] border-l-[1px] last:border-r-[1px] border-[#EAEAEA] h-full border-solid ">
        <div className="w-[94px] flex flex-col items-start justify-center">
            <div className="flex flex-row items-center justify-center w-full space-x-[5px]">
                <img className="w-full h-[20px] rounded-[5px] border-[#CCCCCC] border-[1px] border-solid object-cover" src={
                    data?.firmLogoProfile ?
                        `${apiDomain}${API_CONSTANT.DEFAULT_PROFILE.IMG}${encodeURIComponent(data.firmLogoProfile)}`
                        : data?.firmLogo ?? undefined

                } alt="logo" />
                {countFirm > 2 && <CloseIconWraper className="w-[16px] h-[16px]" onClick={() => { onCloseFirm(data?.firmID ?? 0) }}><CloseIcon /></CloseIconWraper>}
            </div>
            <Link 
                to={`/commerceProfile/${data?.firmID}?tab=home`} 
                title={`${data?.firmName}`} 
                className="underline text-[12px] font-semibold leading-[22px] line-clamp-1"
            >
                {data?.firmName}
            </Link>
        </div>
    </div>
}

export default React.memo(CardFirmCompareComp)

const CloseIcon = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 27 27" fill="none">
        <path d="M13.4998 0.0332031C6.14714 0.0332031 0.166016 6.01432 0.166016 13.367C0.166016 20.7196 6.14714 26.7007 13.4998 26.7007C20.8524 26.7007 26.8335 20.7196 26.8335 13.367C26.8335 6.01432 20.8524 0.0332031 13.4998 0.0332031ZM18.9273 17.4831L17.6148 18.7956L13.4999 14.6795L9.38374 18.7944L8.07248 17.4818L12.1874 13.367L8.07248 9.2508L9.38374 7.93829L13.4999 12.0545L17.6161 7.93829L18.9286 9.2508L14.8124 13.367L18.9273 17.4831Z" fill="#58585B" />
    </svg>
}